import { createAuthClient } from "better-auth/react";
import { adminClient } from "better-auth/client/plugins";
import { API_BASE } from "./api";

// better-auth's baseURL should point at the auth root, e.g. https://api.example.com/api/auth
// In dev (VITE_API_URL empty), we let the Vite proxy handle "/api/auth/*".
// When API_BASE is empty (dev w/ Vite proxy), use the current origin so the URL is absolute.
const origin = API_BASE || (typeof window !== "undefined" ? window.location.origin : "");
const baseURL = `${origin}/api/auth`;

export const authClient = createAuthClient({
  baseURL,
  fetchOptions: {
    credentials: "include",
  },
  plugins: [adminClient()],
});
